<template>
  <div class="example-modal-content formPopupJia" :class="{'formPopupJiaPC':$store.state.innerWidth>980}">
    <div class="popupTitleJia">
      <h1 class="popupTitleH1Jia Bold">{{title}}</h1>
      <!-- <i v-on:click="closeByEvent" style="cursor: pointer;" class="icon-close i-closeJia"></i> -->
    </div>
    <div class="popup-form" v-if="showPage==1">
      <div class="title">{{ $t("message.personal information") }}</div>
      <div class="content">{{ $t("message.quiz content") }}</div>

      <!-- <div class="input-group">
				<b class="i-left">
					<svg t="1640763683004" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7031" width="18" height="18">
						<path d="M512 512c-129.6 0-234.666667-105.066667-234.666667-234.666667S382.4 42.666667 512 42.666667s234.666667 105.066667 234.666667 234.666666-105.066667 234.666667-234.666667 234.666667z m0-85.333333a149.333333 149.333333 0 1 0 0-298.666667 149.333333 149.333333 0 0 0 0 298.666667z m444.096 302.165333c7.466667 16.256 12.714667 39.68 17.28 70.784a1016.725333 1016.725333 0 0 1 7.36 65.642667l0.490667 6.378666L981.333333 874.666667a106.666667 106.666667 0 0 1-106.538666 106.666666H149.205333A106.666667 106.666667 0 0 1 42.666667 874.666667l0.106666-3.029334 0.490667-6.378666a1147.029333 1147.029333 0 0 1 7.36-65.642667c4.565333-31.104 9.813333-54.528 17.28-70.784C100.693333 657.642667 342.08 554.666667 512 554.666667s411.306667 102.976 444.096 174.165333z m-81.856 32.512c-5.973333-5.226667-14.506667-11.498667-25.066667-18.282667-23.637333-15.210667-54.869333-31.466667-89.365333-46.186666C677.12 661.589333 588.437333 640 512 640s-165.098667 21.589333-247.808 56.874667c-34.496 14.72-65.728 30.976-89.365333 46.186666-10.538667 6.784-19.093333 13.056-25.066667 18.282667-2.218667 1.962667-3.925333 3.626667-5.056 4.885333-2.88 7.552-6.506667 24.341333-9.642667 45.781334-2.112 14.293333-3.904 29.738667-5.397333 45.226666-0.768 7.978667-1.322667 14.421333-1.642667 18.581334a21.333333 21.333333 0 0 0 21.184 20.181333h725.589334a21.333333 21.333333 0 0 0 21.184-20.181333c-0.32-4.16-0.853333-10.602667-1.642667-18.56a933.994667 933.994667 0 0 0-5.397333-45.248c-3.136-21.44-6.762667-38.229333-9.642667-45.781334a60.629333 60.629333 0 0 0-5.056-4.885333z" p-id="7032" fill="#707070"></path>
					</svg>
				</b>
				<input 
					type="text"
					v-model="name" 
					:placeholder="$t('message.nameInputTip')" 
					autocomplete="off"
					:aria-label="$t('message.nameInputTip')"
				/>
			</div> -->

      <div class="input-group">
        <b class="i-left">
          <svg t="1640763879480" class="icon" viewBox="0 0 1253 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="7969" width="18" height="18">
            <path
              d="M1139.490309 1024H114.476866a114.012371 114.012371 0 0 1-114.012371-113.801237V113.75901a114.012371 114.012371 0 0 1 114.012371-113.801237h1025.013443a114.012371 114.012371 0 0 1 114.012371 113.801237v796.60866a114.012371 114.012371 0 0 1-114.012371 113.63233z m-79.344165-113.801237l-373.200495-372.862681-24.913814 19.42433a57.048412 57.048412 0 0 1-70.096495 0l-26.898474-21.113402-374.636206 374.425072h869.872165z m-945.880412-85.08701l360.067959-359.814598-360.067959-280.554887V825.111753zM208.220371 113.75901l418.594309 326.159835 418.636536-326.159835H208.220371z m569.048413 353.269444l362.094845 361.757031V184.742268z"
              p-id="7970" fill="#707070"></path>
          </svg>
        </b>
        <input type="text" v-model="email" :placeholder="$t('message.emailInputTip')" autocomplete="off"
          :aria-label="$t('message.emailInputTip')" @blur="onBlur" />
      </div>
      <p v-if="showErrorTips" class="errorTips">{{ $t('message.errorTips') }}</p>

      <div class="formBtn">
        <div class="btn-primary btn-250 SemiBold font-size-14" @click="submit" role="button"
          :aria-label="$t('message.popUp Submit')">
          <a href="javascript:;" style="color: inherit">{{ $t("message.popUp Submit") }}</a>
        </div>
        <div class="btn-primary btn-cancel btn-250 SemiBold font-size-14" @click="closeByEvent" role="button"
          :aria-label="$t('message.popUp Submit')">
          <a href="javascript:;" style="color: inherit">{{ $t("message.Cancel") }}</a>
        </div>
      </div>

      <div class="tips" v-html="$t('message.tips')"></div>
    </div>
    <div class="thanks" v-if="showPage==2">
      <!-- <img src="../images/floating_default.png" alt="" /> -->
      <p class="title" :class="{'enTitle': $store.state.language=='en_US'}">{{ $t("message.thanksTitle") }}</p>
      <p class="content">{{ $t("message.thanksContent") }}</p>
      <p class="tips">{{ $t("message.thanksTips") }}</p>

      <div class="btn-primary btn-cancel btn-250 SemiBold font-size-14" @click="closeByEvent" role="button"
        :aria-label="$t('message.popUp Submit')">
        <a href="javascript:;" style="color: inherit">{{ $t("message.Close") }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['title', 'scoreType', 'occupationsList'],
  data() {
    return {
      quizType: {
        1: 2, // SKILL
        2: 1, // INTEREST
        3: 3, // BGD
      },
      email: '',
      showPage: 1,
      showErrorTips: false,
      // name: "",
    };
  },
  methods: {
    closeByEvent() {
      this.$emit('close');
    },
    submit() {
      let reg =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!reg.test(this.email)) {
        this.showErrorTips = true;
        return;
      }

      let that = this,
        Base64 = require('js-base64').Base64;
      let occupationIds = this.occupationsList.map((item) => {
        return item.id;
      });
      let obj = {
        email: Base64.encode(this.email),
        // name: Base64.encode(this.name),
        occupationIds: Base64.encode(occupationIds.join(',')),
        type: this.quizType[this.scoreType],
      };
      this.api.saveQuizResult(obj, function (data) {
        if (data.errorCode == 0) {
          that.showPage = 2;
          // that.$emit('close');
        }
      });
    },
    onBlur() {
      let reg =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!reg.test(this.email)) {
        this.showErrorTips = true;
      } else {
        this.showErrorTips = false;
      }
    },
  },
};
</script>

<style type="text/css">
#modals-container {
  z-index: 999999;
}
.v--modal-overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}
.departmentJia {
  display: flex;
  flex-direction: column;
}
.popupTitleJia {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.popup-a {
  color: rgb(34, 34, 93);

  padding-bottom: 1px;
}
.popup-link {
  display: inline-block;
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.8);*/
  margin-bottom: 12px;
  margin-top: 26px;
}
.i-closeJia {
  color: rgb(34, 34, 93);
  font-size: 22px;
  margin-top: 5px;
}
</style>